/**
 * TypeScript 4.1 doesn't contain up to date types for the Clipboard API.
 * TODO: Update to at least TypeScript 4.4
 * The problem is that after updating TypeScript, the existing compilation errors
 * can no longer be ignored and the build fails.
 * As a temporary solution, the types are copied from the following source:
 * https://stackoverflow.com/a/67661766/9936008
 */

interface Clipboard {
  read(): Promise<DataTransfer>;
  write(data: ClipboardItemProtoType[]): Promise<void>;
}

interface ClipboardItemProtoType {
  readonly types: string[];
  readonly presentationStyle: "unspecified" | "inline" | "attachment";
  getType(): Promise<Blob>;
}

interface ClipboardItemData {
  [mimeType: string]: Blob | string | Promise<Blob | string>;
}

declare var ClipboardItem: {
  prototype: ClipboardItemProtoType;
  new (itemData: ClipboardItemData): ClipboardItemProtoType;
};

const clipboard = navigator.clipboard as unknown as Clipboard;

const stripSimpleHtml = (htmlContent) =>
  htmlContent
    .replace(/<\/div>/g, "\n\n")
    .replace(/(<\/p>|<\/li>|<\/h\d+>)/g, "\n")
    .replace(/<li>/g, " - ")
    .replace(/<[^>]*>/g, "")
    .replace(/\n\n+/g, "\n\n")
    .trim();

const copyHtmlAsRichText = (htmlContent: string) =>
  clipboard.write([
    new ClipboardItem({
      "text/html": new Blob([htmlContent], {
        type: "text/html",
      }),
      "text/plain": new Blob([stripSimpleHtml(htmlContent)], {
        type: "text/plain",
      }),
    }),
  ]);

export default copyHtmlAsRichText;
